// Port of api/fuel/app/classes/insights/hindex/summary.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'summary',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: [],
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}

        var currentRow = Util.query(
            'SELECT * FROM log_user_hindex WHERE hindex_id = ' + this._data.type.get_id() +
            ' AND user_id = ' + owner.get_id() +
            ' ORDER BY log_hindex DESC LIMIT 1'
        )

        if (!currentRow.length) return {}
        var current = currentRow[0]

        var currentHindex = parseInt(current.log_hindex, 10)
        var nextLevel = currentHindex + 1

        var passed = Util.query(
            'SELECT p.game_id as g FROM play p, game g' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.game_id = g.game_id AND g.game_type = 1' +
            this._data.filter + this._data.playFilter +
            ' GROUP BY p.game_id' +
            ' HAVING SUM(p.play_count) >= ' + nextLevel
        )

        var needed = (currentHindex + 1) - passed.length

        var candidates = Util.query(
            'SELECT p.game_id as g, SUM(p.play_count) AS c' +
            ' FROM play p, game g' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.game_id = g.game_id AND g.game_type = 1' +
            this._data.filter + this._data.playFilter +
            ' GROUP BY p.game_id' +
            ' HAVING SUM(p.play_count) < ' + nextLevel +
            ' ORDER BY SUM(p.play_count) DESC, g.game_name ASC' +
            ' LIMIT 0, ' + needed
        )

        var plays = 0
        for (var i = 0; i < candidates.length; i++) {
            plays += nextLevel - parseInt(candidates[i].c, 10)
        }

        var efficiencyNext = parseInt(current.log_efficiency_next, 10)

        var summary = {
            current: {
                date: parseInt(current.log_date, 10),
                hindex: currentHindex,
                days: parseInt(current.log_days, 10),
                plays: parseInt(current.log_plays_level, 10),
                games: parseInt(current.log_games_level, 10)
            },
            next: {
                days: Math.floor((Util.time() - parseInt(current.log_date, 10)) / Constants.TIME_DAY),
                plays: plays,
                games: needed,
                progress: efficiencyNext ? (100 / efficiencyNext) * (efficiencyNext - plays) : 0
            }
        }

        return {
            summary: summary
        }

    }
})
